import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _JSXStyle from "styled-jsx/style";
import React from 'react';
import withDefaults from '../utils/with-defaults';
var defaultProps = {
  isRight: false,
  className: ''
};

var ButtonIcon = function ButtonIcon(_ref) {
  var isRight = _ref.isRight,
      isSingle = _ref.isSingle,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["isRight", "isSingle", "children", "className"]);

  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: "jsx-3831253408" + " " + (props && props.className != null && props.className || "icon ".concat(isRight ? 'right' : '', " ").concat(isSingle ? 'single' : '', " ").concat(className))
  }), children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3831253408"
  }, ".icon.jsx-3831253408{position:absolute;left:var(--geist-ui-button-padding);right:auto;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--geist-ui-button-color);z-index:1;}.right.jsx-3831253408{right:var(--geist-ui-button-padding);left:auto;}.icon.jsx-3831253408 svg{background:transparent;height:calc(var(--geist-ui-button-height) / 2.35);width:calc(var(--geist-ui-button-height) / 2.35);}.single.jsx-3831253408{position:static;-webkit-transform:none;-ms-transform:none;transform:none;}"));
};

var MemoButtonIcon = /*#__PURE__*/React.memo(ButtonIcon);
export default withDefaults(MemoButtonIcon, defaultProps);